<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_placeholder_search') ||
                  '单号/申请人/申请人部门/付款公司/费用说明/客户订单号/报关发票号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile"
              v-if="allow('E')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-width="140px" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_costBillNo') || '单号'">
              <el-input
                v-model.trim="form.costBillNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_costBillType') || '请款类型'">
              <dict-select
                v-model="form.costBillType"
                :body="{ dictType: 'costBillType' }"
                url="/sys/common/dict/system"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                size="small"
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_salesPersonCode') || '申请人'">
              <dict-select
                v-model="form.salesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_business_person') ||
                    '请选择接受人员'
                "
                size="small"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_depName') || '申请人部门'">
              <dep-cascader
                size="small"
                ref="depCode"
                :lastValue.sync="form.requestDepCode"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_expensePayer') || '付款公司'">
              <dict-select
                v-model="form.costPayerCode"
                :body="expensePayerParams"
                url="/master/common/dict/biz"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_expenseCode') || '费用项目'">
              <expense-select
                v-model="form.expenseCode"
                filterable
                clearable
                :body="{ expenseBizType: 'A' }"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_expenseType') || '财务费用'">
              <dict-select
                v-model="form.expenseType"
                url="/master/common/dict/biz"
                :body="{ dictType: 'expenseType' }"
                filterable
                clearable
                size="small"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_originalExpenseType') || '原始财务费用'"
            >
              <dict-select
                v-model="form.originalExpenseType"
                url="/master/common/dict/biz"
                :body="{ dictType: 'expenseType' }"
                filterable
                clearable
                size="small"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_costDepCode') || '分摊部门'">
              <dep-cascader
                size="small"
                ref="apportionDepCode"
                :lastValue.sync="form.costDepCode"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custCode') || '费用客户'">
              <dict-select
                clearable
                v-model="form.costCustCode"
                url="/digitalCenter/common/dict/customer"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                size="small"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custOrderNo') || '客户订单号'">
              <el-input
                v-model.trim="form.custOrderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_customsNo') || '报关发票号'">
              <el-input
                v-model.trim="form.customsNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_brand') || '品牌'">
              <dict-select
                clearable
                v-model="form.brandCode"
                filterable
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('form_label_please_select_brand') || '请选择品牌'
                "
                style="width: 100%"
                size="small"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_scmCode') || '供应商'">
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.costScmCode"
                :body="scmParams"
                url="/master/common/dict/allScmCooperated"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_requestDate') || '申请日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.requestDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.requestDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_startDate') || '开始日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.startDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.startDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_endDate') || '结束日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_archiveDate') || '审核日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.archiveDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.archiveDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      amazonStoreRegionParams: { dictType: 'amazonStoreRegion' },
      expensePayerParams: { dictType: 'expensePayer' },
      payeeTypeParams: { dictType: 'payeeType' },
      scmParams: {},
      shipPlanTypeParams: { dictType: 'shipPlanType' },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    exportFile() {
      this.$emit('exportFile', this.form)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
